import {
    CREATING_IADB_METADATA_REQUEST,
    CREATING_IADB_METADATA_REQUEST_SUCCEEDED,
    CREATING_IADB_METADATA_REQUEST_FAILED,
    FETCHING_IADB_METADATA_REQUEST,
    FETCHING_IADB_METADATA_REQUEST_SUCCEEDED,
    FETCHING_IADB_METADATA_REQUEST_FAILED,
    FETCHING_IADB_METADATA_LIST_REQUEST_REQUEST,
    FETCHING_IADB_METADATA_LIST_REQUEST_SUCCEEDED,
    FETCHING_IADB_METADATA_LIST_REQUEST_FAILED,
    UPDATING_IADB_METADATA_REQUEST,
    UPDATING_IADB_METADATA_SUCCEEDED,
    UPDATING_IADB_METADATA_FAILED,
    DELETING_IADB_METADATA_REQUEST,
    DELETING_IADB_METADATA_SUCCEEDED,
    DELETING_IADB_METADATA_FAILED,
  } from "constants/actionTypes.jsx";
  
  import axios from "axios";
  import buildUrl from "build-url";
  import { createAction } from "redux-actions";
  import { call, put, takeLatest } from "redux-saga/effects";
  
  const API_URL = process.env.REACT_APP_API_URL;
  const IADB_BASE_URL = `${API_URL}/api/1.0/iadb`;

  /** create metadata */
  export const createIADBMetadata = createAction(CREATING_IADB_METADATA_REQUEST);
  const creatingIADBMetadataSucceeded = createAction(CREATING_IADB_METADATA_REQUEST_SUCCEEDED);
  const creatingIADBMetadataFailed = createAction(CREATING_IADB_METADATA_REQUEST_FAILED);
  
  function* createIADBMetadataSaga(action) {
    let {accountId, metadata } = action.payload;
    var data = {...metadata, account: accountId};
    const createIADBMetadataAPI = () => {
      return axios({
        method: "POST",
        url: IADB_BASE_URL,
        data: data,
      }).then((response) => response.data);
    };
  
    try {
      const response = yield call(createIADBMetadataAPI);
      yield put(creatingIADBMetadataSucceeded(response));
    } catch (error) {
      yield put(creatingIADBMetadataFailed(error));
    }
  }
  
  /** fetch iadb metadata */
  export const fetchIADBMetadata = createAction(FETCHING_IADB_METADATA_REQUEST);
  const fetchingIADBMetadataSucceeded = createAction(FETCHING_IADB_METADATA_REQUEST_SUCCEEDED);
  const fetchingIADBMetadataFailed = createAction(FETCHING_IADB_METADATA_REQUEST_FAILED);
  
  function* fetchIADBMetadataSaga(action) {
    let { accountId, id } = action.payload;
    let url = buildUrl(IADB_BASE_URL, { path: `${id}` });
    const fetchIADBMetadataAPI = () => {
      return axios({
        method: "GET",
        params: {accountId},
        url: url,
      }).then((response) => response.data);
    };
  
    try {
      const response = yield call(fetchIADBMetadataAPI);
      yield put(fetchingIADBMetadataSucceeded(response));
    } catch (error) {
      yield put(fetchingIADBMetadataFailed(error));
    }
  }
  
  /** fetch meta datas */
  export const fetchIADBMetadatas = createAction(FETCHING_IADB_METADATA_LIST_REQUEST_REQUEST);
  const fetchingIADBMetadatasSucceeded = createAction(FETCHING_IADB_METADATA_LIST_REQUEST_SUCCEEDED);
  const fetchingIADBMetadatasFailed = createAction(FETCHING_IADB_METADATA_LIST_REQUEST_FAILED);
  
  function* fetchIADBMetadatasSaga(action) {
    let {accountId} = action.payload;
    let url = buildUrl(IADB_BASE_URL, {path: `/fetch`, queryParams:{accountId: accountId}});
    const fetchIADBMetadatasAPI = () => {
      return axios({
        method: "POST",
        url: url
      }).then((response) => response.data);
    };
  
    try {
      const response = yield call(fetchIADBMetadatasAPI);
      yield put(fetchingIADBMetadatasSucceeded(response));
    } catch (error) {
      yield put(fetchingIADBMetadatasFailed(error));
    }
  }
  
  /** update metadata */
  export const updateIADBMetadata = createAction(UPDATING_IADB_METADATA_REQUEST);
  const updatingIADBMetadataSucceeded = createAction(UPDATING_IADB_METADATA_SUCCEEDED);
  const updatingIADBMetadataFailed = createAction(UPDATING_IADB_METADATA_FAILED);
  
  function* updateIADBMetadataSaga(action) {
    let { id, metadata } = action.payload;
  
    let url = buildUrl(IADB_BASE_URL, { path: `${id}` });
    const updateIADBMetadataAPI = () => {
      return axios({
        method: "PUT",
        url: url,
        data: metadata,
      }).then((response) => response.data);
    };
  
    try {
      const response = yield call(updateIADBMetadataAPI);
      yield put(updatingIADBMetadataSucceeded(response));
    } catch (error) {
      yield put(updatingIADBMetadataFailed(error));
    }
  }
    
  /** delete iadb metadata */
  export const deleteIADBMetadata = createAction(DELETING_IADB_METADATA_REQUEST);
  const deletingIADBMetadataSucceeded = createAction(DELETING_IADB_METADATA_SUCCEEDED);
  const deletingIADBMetadataFailed = createAction(DELETING_IADB_METADATA_FAILED);
  
  function* deleteIADBMetadataSaga(action) {
    let {accountId, id } = action.payload;
    let url = buildUrl(IADB_BASE_URL, { path: `${id}` });
    const deleteIADBMetadataAPI = () => {
      return axios({
        method: "DELETE",
        url: url,
        params: {accountId},
      }).then((response) => response.data);
    };
  
    try {
      const response = yield call(deleteIADBMetadataAPI);
      yield put(deletingIADBMetadataSucceeded(response));
    } catch (error) {
      yield put(deletingIADBMetadataFailed(error));
    }
  }
  
  export default function* iadbMetadataSaga() {
    yield takeLatest(CREATING_IADB_METADATA_REQUEST, createIADBMetadataSaga);  
    yield takeLatest(FETCHING_IADB_METADATA_REQUEST, fetchIADBMetadataSaga);
    yield takeLatest(FETCHING_IADB_METADATA_LIST_REQUEST_REQUEST, fetchIADBMetadatasSaga);
    yield takeLatest(UPDATING_IADB_METADATA_REQUEST, updateIADBMetadataSaga);
    yield takeLatest(DELETING_IADB_METADATA_REQUEST, deleteIADBMetadataSaga);
  }
  